module.exports = __webpack_public_path__ + "img/Regit-2.93ff2082.png";